import * as TranslationAPI from 'api/translation';
import { TranslationResponseType } from 'api/translation';
import { call, put, select } from 'redux-saga/effects';
import { getLabelTranslations } from 'store/translation';
import { actionCreators as translationAT } from 'store/translation/translation.actionCreators';

export function* loadTranslation(action: ReturnType<typeof translationAT.doResolveTranslation>): any {
	const { value } = action; // the label key
	const existingTranslations = yield select(getLabelTranslations, value);

	if (existingTranslations) {
		return;
	}

	try {
		const translations: TranslationResponseType = yield call(TranslationAPI.fetchTranslation, value);

		yield put(
			translationAT.doResolveTranslationSuccess({
				map: {
					de: translations.deValue as string,
					fr: translations.frValue as string,
					it: translations.itValue as string,
				},
				label: value,
			})
		);
	} catch (e) {
		yield put(translationAT.doResolveTranslationFailure(e));
	}
}
